import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import styles from './styles.css';

interface ProgressTextProps {
    texts: string[];
    className?: string;
    textClassName?: string;
}

const MASK_DURATION = 1600;
const FADE_DURATION = 300;

const MASK_START_OFFSET = FADE_DURATION / (MASK_DURATION + FADE_DURATION) / 2;
const MASK_END_OFFSET = 1 - MASK_START_OFFSET;

const animateText = (element: HTMLElement, width: number) =>
    new Promise((resolve) => {
        const maskPosition = `${width * -2}px`;
        const animation = element.animate(
            [
                { maskPosition, opacity: 0, offset: 0 },
                { maskPosition, opacity: 1, offset: MASK_START_OFFSET },
                { maskPosition: 0, opacity: 1, offset: MASK_END_OFFSET },
                { opacity: 0, offset: 1 },
            ],
            {
                duration: MASK_DURATION * 2 + FADE_DURATION * 2,
                iterations: 1,
            }
        );

        animation.onfinish = resolve;
    });
const ProgressText: FunctionComponent<ProgressTextProps> = ({ texts, className, textClassName }) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [textWidth, setTextWidth] = useState(0);
    const [textIndex, setTextIndex] = useState(0);

    const startAnimation = () => {
        if (!textRef.current) {
            return;
        }

        const { width } = textRef.current.getBoundingClientRect();
        setTextWidth(width);

        animateText(textRef.current, width).then(() => {
            setTextIndex((textIndex + 1) % texts.length);
        });
    };

    useEffect(() => {
        startAnimation();
    }, [textIndex]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className={cn(styles.container, className)}>
            <div
                style={textWidth ? { maskSize: `${textWidth * 3}px` } : undefined}
                className={cn(styles.text, textClassName)}
                ref={textRef}
            >
                {texts[textIndex]}
            </div>
        </div>
    );
};

export { ProgressText };
